import React from 'react'
import style from './card.module.css'

function Shyam() {
  return (
    <div className = {style.sumit}>
        <img src='https://edge.uacdn.net/static/thumbnail/user/bb1ea3cb6bd6433c935d1b79e5da47e2.jpg?q=75&w=1000&fm=webp' alt='_Sumit_img'/>
        <div>
            <h1>Shyam Sharma</h1> 
            <p>
                EX NAVODYAN GAT(EXPART)
                Qualified UPSC CDS, NDA Selected 
                in AIRFORCE Mentor for DEFENCE ASPIRANT  
            </p> 
            <p>Teaches General Science and 39 more</p>  
        </div> 
    </div>
  )
}
export default Shyam